import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Input,
  Form,
  Modal,
  Space,
  Popconfirm,
  message,
  Select,
  Card,
  Popover,
  DatePicker,
  Divider,
} from "antd";

import moment from "moment";

import {
  GetBoatSets,
  AddNewBoatSet,
  GetBoats,
  AddNewBoat,
  GetBookings,
  GetSchoolNames,
  AddNewBooking,
  GetBlockedSlots,
  AddNewBlockedSlot,
  DeleteBooking,
  DeleteBlockedSlot,
  OpenPDFSchedule,
} from "../../../APIManager";

import styles from "./BoatsBooking.module.css";

const TimeSlots = [
  "07:00-07:50 AM",
  "08:00-08:50 AM",
  "09:00-09:50 AM",
  "10:00-10:50 AM",
  /*  "11:00-11:50 AM",
  "12:00-12:50 PM",
  "01:00-01:50 PM",
  "02:00-02:50 PM", */
  "03:00-03:50 PM",
  "04:00-04:50 PM",
  "05:00-05:50 PM",
  /*   "06:00-06:50 PM",
  "07:00-07:50 PM", */
];

const dateFormat = "DD/MM/YYYY";

const PKT_OFFSET = 5; // hours

function toUtcFromPakistanDay(dateLike) {
  return moment(dateLike)
    .utcOffset(PKT_OFFSET, true) // interpret as PKT without shifting clock
    .startOf("day") // 00:00 PKT
    .utc(); // convert to UTC instant
}

const { Option } = Select;

const BoatsBooking = () => {
  const [boatSets, setBoatSets] = useState([]);
  const [boats, setBoats] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [blockedSlots, setBlockedSlots] = useState([]);
  const [schools, setSchools] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    toUtcFromPakistanDay(moment().utcOffset(PKT_OFFSET))
  );
  const [loading, setLoading] = useState(false);

  const [addSchoolBookingModalVisible, setAddSchoolBookingModalVisible] =
    useState(false);
  const [addSchoolBookingForm] = Form.useForm();

  const [addBlockedSlotModalVisible, setAddBlockedSlotModalVisible] =
    useState(false);
  const [addBlockedSlotForm] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    try {
      // Run all requests in parallel
      const [resSets, resBoats, resBookings, resSchoolNames, resBlockedSlots] =
        await Promise.all([
          GetBoatSets(),
          GetBoats(),
          GetBookings(),
          GetSchoolNames(),
          GetBlockedSlots(),
        ]);

      const sets = resSets.data;
      const boats = resBoats.data;
      const bookings = resBookings.data;
      const schoolNames = resSchoolNames.data;
      const blockedSlots = resBlockedSlots.data;

      // Map boats into their sets
      const setsWithBoats = sets.map((set) => ({
        ...set,
        boats: boats.filter((boat) => boat.BoatSet._id === set._id),
      }));

      setBookings(bookings);
      setSchools(schoolNames);
      setBoatSets(setsWithBoats);
      setBoats(boats);
      setBlockedSlots(blockedSlots);

      console.log({ setsWithBoats });
    } catch (err) {
      message.error("Failed to fetch boat sets");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Fetch immediately on mount
    fetchData();

    // Set interval to fetch every 1 minute
    const interval = setInterval(() => {
      fetchData();
    }, 60 * 1000); // 60 seconds

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  const todaysBookings = filterBookingsByDay(bookings, selectedDate, "Date");
  const todaysBlockedSlots = filterBookingsByDay(
    blockedSlots,
    selectedDate,
    "Date"
  );

  console.log({ selectedDate });
  console.log({ todaysBookings });

  const handleAddSchoolBooking = async (values) => {
    const allValues = addSchoolBookingForm.getFieldsValue(true);
    setAddSchoolBookingModalVisible(false);
    addSchoolBookingForm.resetFields();

    try {
      await AddNewBooking({
        School: allValues.SchoolId,
        Boat: allValues.BoatId,
        BoatSet: allValues.BoatSetId,
        TimeSlot: allValues.TimeSlot,
        Date: allValues.Date,
      });
      message.success("Booking Added Successfully");

      fetchData();
    } catch (err) {
      message.error(err.response?.data?.error || "Failed to add Booking");
    }
  };

  const handleAddBlockedSlot = async (values) => {
    const allValues = addBlockedSlotForm.getFieldsValue(true);
    setAddBlockedSlotModalVisible(false);

    try {
      await AddNewBlockedSlot({
        Reason: allValues.Reason,
        Boat: allValues.BoatId,
        BoatSet: allValues.BoatSetId,
        TimeSlot: allValues.TimeSlot,
        Date: allValues.Date,
      });
      message.success("Slot Blocked Successfully");

      addBlockedSlotForm.resetFields();
      fetchData();
    } catch (err) {
      message.error(err.response?.data?.error || "Failed to blocked slot");
    }
  };

  const onAddSchoolBooking = (timeSlot, boatId, boatSetId) => {
    addSchoolBookingForm.setFieldsValue({
      TimeSlot: timeSlot,
      BoatId: boatId,
      BoatSetId: boatSetId,
      Date: selectedDate,
    });
    setAddSchoolBookingModalVisible(true);
  };

  const onAddBlockedSlot = (timeSlot, boatId, boatSetId) => {
    addBlockedSlotForm.setFieldsValue({
      TimeSlot: timeSlot,
      BoatId: boatId,
      BoatSetId: boatSetId,
      Date: selectedDate,
    });
    setAddBlockedSlotModalVisible(true);
  };

  const onDeleteBooking = async (bookingId) => {
    try {
      await DeleteBooking({ id: bookingId });
      message.success("Booking Deleted Successfully");
      fetchData();
    } catch (err) {
      message.error(err.response?.data?.error || "Failed to delete booking");
    }
  };

  const onDeleteBlockedSlot = async (blockedSlotId) => {
    try {
      await DeleteBlockedSlot({ id: blockedSlotId });
      message.success("Un-Blocked Successfully");
      fetchData();
    } catch (err) {
      message.error(err.response?.data?.error || "Failed to un-block slot");
    }
  };

  return (
    <div>
      <Divider>
        {" "}
        <strong>Boats Booking</strong>
      </Divider>
      <span>Local Time: {new Date().toLocaleString()}</span>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Left side text */}
        <span className={styles.DateText}>
          {moment(selectedDate).utcOffset(5).format("dddd, MMMM D, YYYY")}
          <Button
            type="link"
            onClick={() => {
              OpenPDFSchedule(selectedDate.clone().utc().toISOString());
            }}
          >
            Download PDF
          </Button>
        </span>

        {/* Right side controls */}
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <Button
            onClick={() =>
              setSelectedDate(
                toUtcFromPakistanDay(
                  moment(selectedDate).utcOffset(PKT_OFFSET).subtract(1, "day")
                )
              )
            }
          >
            Previous
          </Button>

          <Button
            onClick={() =>
              setSelectedDate(
                toUtcFromPakistanDay(moment().utcOffset(PKT_OFFSET))
              )
            }
          >
            Today
          </Button>
          <Button
            onClick={() =>
              setSelectedDate(
                toUtcFromPakistanDay(
                  moment(selectedDate).utcOffset(PKT_OFFSET).add(1, "day")
                )
              )
            }
          >
            Next
          </Button>
          <DatePicker
            value={moment(selectedDate).utcOffset(PKT_OFFSET)}
            onChange={(date) => {
              date && setSelectedDate(toUtcFromPakistanDay(date));
            }}
            format={dateFormat}
            allowClear={false}
          />
        </div>
      </div>
      <br />
      <div>
        {boatSets.length > 0 && (
          <div>
            {boatSets.map((boatSet) => (
              <BoatSetTable
                boatSet={boatSet}
                bookings={todaysBookings}
                blockedSlots={todaysBlockedSlots}
                onAddSchoolBooking={onAddSchoolBooking}
                onAddBlockedSlot={onAddBlockedSlot}
                onDeleteBooking={onDeleteBooking}
                onDeleteBlockedSlot={onDeleteBlockedSlot}
                selectedDate={selectedDate}
                key={boatSet._id}
              />
            ))}
          </div>
        )}
      </div>

      {/* Modal to add school booking */}
      <Modal
        title="Add School Booking"
        visible={addSchoolBookingModalVisible}
        onCancel={() => {
          setAddSchoolBookingModalVisible(false);
          addSchoolBookingForm.resetFields();
        }}
        onOk={() => addSchoolBookingForm.submit()}
      >
        <Form
          form={addSchoolBookingForm}
          onFinish={handleAddSchoolBooking}
          layout="vertical"
        >
          <div>
            Date:{" "}
            {addSchoolBookingForm.getFieldValue("Date")
              ? moment(addSchoolBookingForm.getFieldValue("Date")).format(
                  "dddd, MMMM D, YYYY"
                )
              : ""}
          </div>
          <div>Time Slot: {addSchoolBookingForm.getFieldValue("TimeSlot")}</div>
          <div>
            Boat Set:{" "}
            {
              boatSets.find(
                (bs) =>
                  bs._id == addSchoolBookingForm.getFieldValue("BoatSetId")
              )?.Name
            }
          </div>
          <div>
            Boat:{" "}
            {
              boats.find(
                (bs) => bs._id == addSchoolBookingForm.getFieldValue("BoatId")
              )?.Name
            }
          </div>
          <br />
          <Form.Item
            label="School Name"
            name="SchoolId"
            rules={[{ required: true, message: "Please select a school" }]}
          >
            <Select
              placeholder="Select a school"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {schools
                .sort((a, b) => a.username.localeCompare(b.username)) // Sort alphabetically
                .map((school) => (
                  <Select.Option key={school._id} value={school._id}>
                    {school.username}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal to add blocked slot */}
      <Modal
        title="Block Time Slot"
        visible={addBlockedSlotModalVisible}
        onCancel={() => {
          setAddBlockedSlotModalVisible(false);
          addBlockedSlotForm.resetFields();
        }}
        onOk={() => addBlockedSlotForm.submit()}
      >
        <Form
          form={addBlockedSlotForm}
          onFinish={handleAddBlockedSlot}
          layout="vertical"
        >
          <div>
            Date:{" "}
            {addBlockedSlotForm.getFieldValue("Date")
              ? moment(addBlockedSlotForm.getFieldValue("Date")).format(
                  "dddd, MMMM D, YYYY"
                )
              : ""}
          </div>
          <div>Time Slot: {addBlockedSlotForm.getFieldValue("TimeSlot")}</div>
          <div>
            Boat Set:{" "}
            {
              boatSets.find(
                (bs) => bs._id == addBlockedSlotForm.getFieldValue("BoatSetId")
              )?.Name
            }
          </div>
          <div>
            Boat:{" "}
            {
              boats.find(
                (bs) => bs._id == addBlockedSlotForm.getFieldValue("BoatId")
              )?.Name
            }
          </div>
          <br />
          <Form.Item
            label="Reason"
            name="Reason"
            rules={[
              {
                required: true,
                message: "Please enter the reason",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

function BoatSetTable({
  boatSet,
  bookings,
  blockedSlots,
  onDeleteBooking,
  onAddSchoolBooking,
  onAddBlockedSlot,
  onDeleteBlockedSlot,
  selectedDate,
}) {
  const columns = [
    /* { title: "S.No", dataIndex: "index", width: 60 }, */
    {
      title: "Boat Type",
      dataIndex: "Name",
      width: 180,
      fixed: "left",
      render: (text) => <span style={{ fontWeight: "bold" }}>{text}</span>,
    },

    ...TimeSlots.map((slot) => ({
      title: (
        <div style={{ fontWeight: "bold", textAlign: "center" }}>{slot}</div>
      ),
      dataIndex: slot,
      onCell: (row) => {
        const booking = bookings.find(
          (b) => b.Boat._id === row._id && b.TimeSlot === slot
        );

        const blocked = blockedSlots.find(
          (b) => b.Boat._id === row._id && b.TimeSlot === slot
        );

        const unavailable = row.Unavailable;
        const adminBookingOnly = row.AdminBookingOnly;

        let cellClass = styles.PopCell; // base class

        if (unavailable) {
          cellClass += ` ${styles.Unavailable}`;
        } else if (booking) {
          cellClass += ` ${styles.Booked}`;
        } else if (blocked) {
          cellClass += ` ${styles.Blocked}`;
        } else if (adminBookingOnly) {
          cellClass += ` ${styles.AdminBookingOnly}`;
        } else {
          cellClass += ` ${styles.Available}`;
        }

        return { className: cellClass };
      },

      render: (value, row) => {
        const booking = bookings.find(
          (b) => b.Boat._id === row._id && b.TimeSlot === slot
        );
        const blocked = blockedSlots.find(
          (b) => b.Boat._id === row._id && b.TimeSlot === slot
        );

        const unavailable = row.Unavailable;
        const adminBookingOnly = row.AdminBookingOnly;

        if (unavailable) {
          return (
            <div>
              <div className={styles.SchoolInitials}>Unavailable</div>
            </div>
          );
        }

        if (!booking && !blocked) {
          const availablePopContent = (
            <div>
              <p>
                <div>{slot}</div>
                <b>Available</b>
              </p>
              <Button
                size="small"
                onClick={() => {
                  // First check if the slot is in the past
                  if (isSlotInPast(selectedDate, slot)) {
                    message.error("Cannot book a slot in the past.");
                    return;
                  }
                  if (unavailable) {
                    message.error("This boat is unavailable for bookings");
                    return;
                  }
                  /* 
                  const bookingCheck = canBookSlot(selectedDate, 0, "08:00");

                  if (!bookingCheck.canBook) {
                    message.error(bookingCheck.message); // Show the friendly message
                    return;
                  } */

                  // If all checks pass, proceed with booking
                  onAddSchoolBooking(slot, row._id, boatSet._id);
                }}
              >
                Assign School
              </Button>
              <Button
                size="small"
                onClick={() => {
                  if (isSlotInPast(selectedDate, slot)) {
                    message.error("Cannot block a slot in the past.");
                    return;
                  }

                  if (unavailable) {
                    message.error("This boat is already unavailable");
                    return;
                  }
                  onAddBlockedSlot(slot, row._id, boatSet._id);
                }}
              >
                Block
              </Button>
            </div>
          );

          return (
            <Popover
              trigger="click"
              content={availablePopContent}
              placement="top"
              zIndex={999}
            >
              <div>
                {" "}
                {adminBookingOnly ? "On Request" : "Available"}
              </div>
            </Popover>
          );
        }

        if (booking) {
          // Popover for blocked cell
          const bookedPopContent = (
            <div>
              <p>
                <div>{slot}</div>
                <b>{booking.School.schoolinitials}</b>
              </p>
              <Button
                danger
                size="small"
                onClick={() => onDeleteBooking(booking._id)}
                disabled={isSlotInPast(selectedDate, slot)}
              >
                Delete Booking
              </Button>
            </div>
          );

          return (
            <Popover trigger="click" content={bookedPopContent} placement="top">
              <div className={styles.SchoolInitials}>
                {booking.School.schoolinitials}
              </div>
            </Popover>
          );
        }

        if (blocked) {
          // Popover for booked cell
          const blockedPopover = (
            <div>
              <p>
                <div>{slot}</div>
                <b>{blocked.Reason}</b>
              </p>
              <Button
                danger
                size="small"
                onClick={() => onDeleteBlockedSlot(blocked._id)}
                disabled={isSlotInPast(selectedDate, slot)}
              >
                Un-Block
              </Button>
            </div>
          );

          return (
            <Popover trigger="click" content={blockedPopover} placement="top">
              <div className={styles.SchoolInitials}>{blocked.Reason}</div>
            </Popover>
          );
        }
      },
    })),
  ];

  const data = boatSet.boats.map((boat, i) => ({
    ...boat,
    index: i + 1,
  }));

  return (
    <div>
      <div className={styles.BoatSetName}>{boatSet.Name}</div>
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        bordered
        size="small"
        className={styles.disableRowHover}
        scroll={{ x: "750px" }} // <-- horizontal scroll if table too wide
      />
    </div>
    /*  <Card title={`${boatSet.Name}`} style={{ marginBottom: 20 }}>
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        bordered
        size="small"
        className={styles.disableRowHover}
      />
    </Card> */
  );
}

export default BoatsBooking;

function isSlotInPast(date, slot) {
  if (!date || !slot) return false;

  const [timeRange, meridiem] = slot.split(" "); // "07:00-07:50 AM" => ["07:00-07:50", "AM"]
  const [startTime] = timeRange.split("-"); // "07:00-07:50" => "07:00"

  let [hours, minutes] = startTime.split(":").map(Number);

  if (meridiem === "PM" && hours < 12) hours += 12;
  if (meridiem === "AM" && hours === 12) hours = 0;

  const slotDateTime = new Date(date);
  slotDateTime.setHours(hours, minutes, 0, 0);

  return slotDateTime < new Date(); // compare with current date-time
}

function canBookSlot(selectedDate, advanceBookingDays, bookingOpenTime) {
  if (!selectedDate || !bookingOpenTime) {
    return { canBook: false, message: "Invalid booking date or rules." };
  }

  const now = new Date();

  // Compute the date and time when booking opens
  const bookingOpenDate = new Date(selectedDate);
  bookingOpenDate.setDate(bookingOpenDate.getDate() - advanceBookingDays);

  const [hours, minutes] = bookingOpenTime.split(":").map(Number);
  bookingOpenDate.setHours(hours, minutes, 0, 0);

  if (now < bookingOpenDate) {
    const options = { weekday: "long", month: "long", day: "numeric" };
    const openDateStr = bookingOpenDate.toLocaleDateString(undefined, options);
    const openTimeStr = bookingOpenDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    return {
      canBook: false,
      message: `Booking for this date will open on ${openDateStr} at ${openTimeStr}.`,
    };
  }

  return { canBook: true, message: "" };
}

const getRandomStatusClass = () =>
  ["Disabled", "Booked", "Available", "SelfBooked"][
    Math.floor(Math.random() * 4)
  ];

/**
 * Filter objects whose date matches today in local time
 * @param {Array<Object>} arr - Array of objects
 * @param {string} dateProp - Name of the property holding the Date
 * @returns {Array<Object>} Filtered objects for today
 */
function filterBookingsByDay(bookings, selectedDate, dateProp = "Date") {
  if (!selectedDate) return bookings; // Return all if no date is provided
  const targetPkt = moment(selectedDate)
    .utc()
    .utcOffset(PKT_OFFSET * 60);

  return bookings.filter(({ [dateProp]: dateValue }) => {
    const bookingPkt = moment(dateValue)
      .utc()
      .utcOffset(PKT_OFFSET * 60);
    return bookingPkt.isSame(targetPkt, "day");
  });
}
